import * as React from 'react';
import { observer } from 'mobx-react';
import * as parse from 'date-fns/parse';
import * as distanceInWordsStrict from 'date-fns/distance_in_words_strict';

// Type
import { IComment } from './CommentsDialog';

// Assets
const QuestionSVG = require('../../assets/illustrations/question.svg') as string;

// Components
import Comment from '../Comment';
import Divider from '../Divider';
import { CircularProgress } from '../Progress';
import Typography from '../Typography';

// Component
interface IProps {
  comments: IComment[] | null;
}

function CommentsDialogList(props: IProps) {
  if (props.comments === null) {
    return (
      <div
        style={{
          height: 400,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  if (props.comments.length === 0) {
    return (
      <div
        style={{
          height: 400,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <img src={QuestionSVG} width={192} height={192} />
        <Typography type={'headline'}>Start the conversation</Typography>
        <Typography type={'subheading'}>
          Use the field below to start the discussion.
        </Typography>
      </div>
    );
  } else {
    return (
      <div style={{ minHeight: 400 }}>
        {props.comments.map(item => [
          <Comment
            key={item.commentId}
            avatarSrc={item.photoUrl}
            firstName={item.firstName}
            lastName={item.lastName}
            comment={item.comment}
            timeLabel={distanceInWordsStrict(
              new Date(),
              parse(`${item.created}Z`)
            )}
            dangerouslySetInnerHTML={true}
          />,
          <Divider key={item.commentId + '_D'} />
        ])}
      </div>
    );
  }
}

export default observer(CommentsDialogList);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CommentsDialog/CommentsDialogList.tsx